import { PropType } from 'vue';
import BaseListItemSetupService, { DetailPrefixForRouter } from '@/setup/BaseListItemSetupService';
import TimeTicketListItemEntity from '@/entity/time-ticket/TimeTicketListItemEntity';

type Props = SetupProps<typeof BaseTimeTicketEntitySetupService.props>

export default abstract class BaseTimeTicketEntitySetupService<P> extends BaseListItemSetupService<Props & P> {
	protected detailPrefixForRouter = DetailPrefixForRouter.TimeTicket;

	static readonly props = {
		...BaseListItemSetupService.props,
		timeTicket: {
			type: Object as PropType<Armado.TimeTicketWeekYear>,
			default: null,
		},
	};

	timeTicket = new TimeTicketListItemEntity(this.props.timeTicket);

	protected get itemId () { return undefined; }


	constructor (props: Props & P) {
		super(props);
	}
}
